import React, { useState } from 'react';
import { NotificationBanner } from '@cmhc-schl/hearth-ui';
import { useTranslation } from 'react-i18next';
import { Arrears } from '../../core/Arrears';

export const ArrearsFlyoutWarningBanner = ({ arrears }: { arrears: Arrears }) => {
  const { t } = useTranslation('HbtArrearsInquiryPage');
  const [isVisible, setVisible] = useState(arrears.loanInformationMissing);

  return (
    <NotificationBanner
      showNotificationBanner={isVisible}
      onCloseNotificationBanner={() => setVisible(false)}
      headerText={{ value: t('arrearsFlyout.warningBanner.title') }}
      message={{ value: t('arrearsFlyout.warningBanner.message') }}
      variant={'Warning'}
    />
  );
};
